interface Array<T> {
	sortNaturallyByRegexGroups(property: string, isAsc: boolean, regex: RegExp): Array<T>;

	sortNaturallyByStringAndNumberGroups(property: string, isAsc: boolean): Array<T>;
}

Array.prototype.sortNaturallyByStringAndNumberGroups = function (property: string, isAsc: boolean) {
	return this.sortNaturallyByRegexGroups(property, isAsc, /(\d+)|(\D+)/gi);
};

Array.prototype.sortNaturallyByRegexGroups = function (property: string, isAsc: boolean, regex: RegExp) {
	return this.sort((a, b) => {
		if (!a || !b || !a[property] || !b[property]) {
			return 0;
		}
		const groupsA = (a[property] as string).match(regex);
		const groupsB = (b[property] as string).match(regex);

		if (!groupsA || !groupsA.length) {
			return -1 * (isAsc ? 1 : -1);
		}
		if (!groupsB || !groupsB.length) {
			return 1 * (isAsc ? 1 : -1);
		}

		const loops = groupsA.length > groupsB.length ? groupsA.length : groupsB.length;
		for (let i = 0; i < loops; i++) {
			let compareA;
			let compareB;
			try {
				compareA = groupsA[i].trim();
				compareB = groupsB[i].trim();
			} catch (err) {
				// one array is smaller than the other, hence trim fails on undefined, but they're equal so far
				// now the smaller one wins
				return (groupsA.length < groupsB.length ? -1 : 1) * (isAsc ? 1 : -1);
			}
			const comparison = compareA.localeCompare(compareB, undefined, {
				numeric: true,
				sensitivity: 'base',
			});
			if (comparison !== 0) {
				return comparison * (isAsc ? 1 : -1);
			}
		}
	});
};
